// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","bold":"G378d56 G42bbcd","header":"Gf064dd","subHeader":"Gc37219","dateTime":"G485455","button":"G59879a"};